module.exports = __webpack_public_path__ + "r-v3/img/ico_device_audiooutput.e59885a6.svg";